/* unplugin-vue-components disabled */import script from "./contentCarousel.vue?vue&type=script&lang=js"
export * from "./contentCarousel.vue?vue&type=script&lang=js"

import "./contentCarousel.vue?vue&type=style&index=0&id=ac15e178&lang=scss"

const __exports__ = script;

export default __exports__